import { useCallback } from 'react';
import type { EventListItemType } from 'features/events';
import { useMapPrincipalCalendarCategoryToEventType, useMapPrincipalCalendarEventStatus } from '../../hooks';
import type { EventItem } from '../Agenda';
import { useGetSplitId } from './useGetSplitId';

export const useCreateEventListItem = () => {
  const getSplitId = useGetSplitId();
  const mapPrincipalCalendarEventStatus = useMapPrincipalCalendarEventStatus();
  const mapPrincipalCalendarCategoryToEventType = useMapPrincipalCalendarCategoryToEventType();

  return useCallback(
    ({ event }: { event: EventItem }): EventListItemType => {
      if (event.type === 'rails') {
        return {
          agendaTimeDisplay: event.agendaTimeDisplay,
          endTime: event.data.endTime,
          eventType: event.data.eventType,
          goingInviteesCount: event.data.goingInviteesCount,
          id: event.data.id,
          name: event.data.name,
          recordingStatus: event.data.recordingStatus,
          startTime: event.data.startTime,
          status: event.data.status,
        };
      }

      return {
        agendaTimeDisplay: event.agendaTimeDisplay,
        endTime: event.end,
        eventType: mapPrincipalCalendarCategoryToEventType(event.data.categories[0]),
        goingInviteesCount: event.data.goingCount,
        id: getSplitId(event.data.id),
        isAllDay: event.data.isAllDay,
        name: event.data.summary,
        recordingStatus: event.data.hasRecording ? 'recorded' : undefined,
        startTime: event.start,
        status: mapPrincipalCalendarEventStatus(event.data.status),
      };
    },
    [getSplitId, mapPrincipalCalendarEventStatus, mapPrincipalCalendarCategoryToEventType],
  );
};
